import { geoHttp, reportHttp } from '@/utils/http/request'
import { API_ENDPOINTS } from '@/config/api'
import type { IUserInfo } from '@/types/home'
import { invokeSafe } from '@kiti/js-bridge'

/**
 * 接口示例，走端代理
 */
export async function postKitiReport(params: Record<string, any>) {
  return reportHttp.post<ApiResponse<null>>(API_ENDPOINTS.REPORT.H5_REPORT, params, {
    headers: {
      // 前端内部标记：拦截器识别后会删除，不会发给后端。
      // reportHttp 默认会给请求头加 lang，但 reportH5 的 lang 已在 body 里（useReport），
      // 避免 header/body 重复导致验签不一致，此处跳过自动注入 lang。
      //其他接口不受影响
      'x-skip-lang-header': '1'
    }
  })
}

/**
 * 获取用户所属国家
 */
export const getGeoCountry = () =>
  geoHttp.get<ApiResponse<string>>('/kiti-app2/api/anon/geo/country')

export async function fetUserInfo() {
  return invokeSafe<ApiResponse<IUserInfo>>('getRequest', {
    path: 'kiti-chat/outer/customer/acquire-customer'
  })
}
